<div class="form-group row">
  <div class="col-12">
    <form
      [formGroup]="indicationForm"
      novalidate
      class="needs-validation"
      (ngSubmit)="onSubmit()"
    >
      <div class="panel-content">
        <div class="form-row">
          <input type="hidden" id="id" formControlName="id" *ngIf="!editMode" />
          <input
            type="hidden"
            id="createdOn"
            formControlName="createdOn"
            *ngIf="!editMode"
          />
          <input
            type="hidden"
            id="updatedOn"
            formControlName="updatedOn"
            *ngIf="!editMode"
          />
        </div>
        <div class="form-row mb-3">
          <div class="col-12">
            <label class="form-label" for="name"
              >Nome <span class="text-danger" *ngIf="!previewMode">*</span>
            </label>
            <div *ngIf="previewMode">
              <label class="form-control font-weight-bold disabled">{{
                f.name.value
              }}</label>
            </div>
            <div *ngIf="!previewMode">
              <input
                type="text"
                id="name"
                formControlName="name"
                class="form-control"
                placeholder="Nome do Contato"
                [ngClass]="{ 'is-invalid': !validContact && f.name.errors }"
                required
              />
              <div
                *ngIf="!validContact && f.name.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.name.errors.required">
                  Por favor, informe o nome do contato.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row mb-3">
          <div class="col-6">
            <div class="form-group">
              <label class="form-label" for="email"
                >E-mail
                <span class="text-danger" *ngIf="!previewMode">*</span></label
              >
              <div *ngIf="previewMode">
                <label class="form-control font-weight-bold disabled">{{
                  f.email.value
                }}</label>
              </div>
              <div *ngIf="!previewMode">
                <input
                  type="text"
                  id="email"
                  formControlName="email"
                  class="form-control"
                  placeholder="E-mail do contato"
                  [ngClass]="{ 'is-invalid': !validContact && f.email.errors }"
                  required
                />
                <div
                  *ngIf="!validContact && f.email.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.email.errors.required">
                    Por favor, informe o e-mail do contato.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class="form-label" for="phone"
                >Telefone
                <span class="text-danger" *ngIf="!previewMode">*</span></label
              >
              <div *ngIf="previewMode">
                <label class="form-control font-weight-bold disabled">{{
                  f.phone.value
                }}</label>
              </div>
              <div *ngIf="!previewMode">
                <input
                  type="tel"
                  id="phone"
                  formControlName="phone"
                  class="form-control"
                  placeholder="Telefone do contato"
                  [ngClass]="{ 'is-invalid': !validContact && f.phone.errors }"
                  required
                  (input)="onPhoneInput($event)"
                  maxlength="15"
                />
                <div
                  *ngIf="!validContact && f.phone.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.phone.errors.required">
                    Por favor, informe o telefone do contato.
                  </div>
                  <div *ngIf="f.phone.errors.phone">
                    Por favor, informe um telefone válido.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label" for="message">Mensagem</label>
              <div *ngIf="previewMode">
                <div
                  class="panel-tag"
                  [innerHTML]="getFormattedMessage(f?.message?.value)"
                ></div>
              </div>
              <div *ngIf="!previewMode">
                <textarea
                  rows="3"
                  id="message"
                  formControlName="message"
                  placeholder="Mensagem do contato"
                  maxlength="300"
                  class="form-control rounded-top border-bottom-left-radius-0 border-bottom-right-radius-0 border"
                  (keydown)="countMessageLength($event)"
                  (change)="countMessageLength($event)"
                ></textarea>
                <span
                  class="badge badge-info text-white fw-400 px-1 pull-right mt-1"
                >
                  {{ messageLength }} / 300
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row no-gutters">
          <div class="col-12">
            <div class="subheader mb-2">
              <div class="subheader-block d-lg-flex align-items-center">
                <div
                  class="d-inline-flex flex-column justify-content-center mr-3"
                >
                  <span class="fw-300 fs-xs d-block text-muted"
                    >Data de Criação:</span
                  >
                  <span
                    class="fw-500 fs-xs d-block color-primary-500"
                    *ngIf="indicationId > 0"
                    >{{
                      indication?.createdOn | date : "dd/MM/yyyy HH:mm:ss"
                    }}</span
                  >
                  <span
                    class="fw-500 fs-xs d-block color-primary-500"
                    *ngIf="!indication"
                    >{{ dateNow | date : "dd/MM/yyyy HH:mm:ss" }}</span
                  >
                </div>
              </div>
              <div
                class="subheader-block d-lg-flex align-items-center border-faded border-right-0 border-top-0 border-bottom-0 ml-3 pl-3"
              >
                <div
                  class="d-inline-flex flex-column justify-content-center mr-3"
                >
                  <span class="fw-300 fs-xs d-block text-muted"
                    >Data de Atualização:</span
                  >
                  <span
                    class="fw-500 fs-xs d-block color-primary-500"
                    *ngIf="indicationId > 0"
                    >{{
                      indication?.updatedOn | date : "dd/MM/yyyy HH:mm:ss"
                    }}</span
                  >
                  <span
                    class="fw-500 fs-xs d-block color-primary-500"
                    *ngIf="!indication"
                    >{{ dateNow | date : "dd/MM/yyyy HH:mm:ss" }}</span
                  >
                </div>
              </div>
              <div
                class="subheader-block d-lg-flex align-items-center border-faded border-right-0 border-top-0 border-bottom-0 ml-3 pl-3"
              >
                <div
                  class="d-inline-flex flex-column justify-content-center mr-3"
                >
                  <span class="fw-300 fs-xs d-block text-muted" for="statusCrm"
                    >Status:</span
                  >
                  <span
                    class="badge badge-pill w-100 status-sdr"
                    *ngIf="previewMode"
                    [ngClass]="
                      indication?.id > 0 ? indication?.statusCrmCss : ''
                    "
                    >{{ indication?.statusCrmStr }}</span
                  >
                  <span
                    class="badge badge-pill w-100 status-sdr"
                    *ngIf="!previewMode"
                    [ngClass]="newStatusCrmCss"
                    >{{ newStatusCrmStr }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="col-12 ml-auto text-right mt-3">
            <div class="btn-group btn-panel">
              <button
                id="js-cancel-btn"
                class="btn btn-default"
                (click)="onCancel()"
              >
                {{ cancelButtonText }}
              </button>
              <button
                id="js-login-btn"
                class="btn btn-primary"
                [disabled]="submitted"
                *ngIf="!previewMode"
              >
                <span
                  *ngIf="submitted"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                Salvar
              </button>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="!validIndication">
          <hr />
          <div class="col-md-12">
            <div
              class="alert alert-warning alert-dismissible text-left fade show mt-3"
              role="alert"
              *ngIf="!validContact"
            >
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true"><i class="fal fa-times"></i></span>
              </button>
              {{ errorMessage }}
            </div>
            <br />
            <div
              *ngIf="listErrorMessage && !validContact"
              class="invalid-feedback"
            >
              <div *ngFor="let error of listErrorMessage">{{ error }}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
